'use client';

import { useState } from 'react';

export default function AccountAvatar({ image, initials }: { image: string | null; initials: string }) {
  const [failedImage, setFailedImage] = useState<string | null>(null);
  return image && failedImage !== image
    ? <img src={image} alt="" className="h-full w-full rounded-full object-cover" onError={() => setFailedImage(image)} />
    : <span aria-hidden="true" className="flex h-full w-full items-center justify-center rounded-full bg-primary-light text-xs font-semibold text-primary">{initials}</span>;
}
